module.exports = __webpack_public_path__ + "images/create-first-board/card-drag/zh-hant-card-drag.40382ea3c87d3f027666.gif";